import inputsConfig from "../inputConfig";

export default {
  accordion: false,
  items: [
    {
      name: "New company name",
      required: true,
      fields: inputsConfig.organization,
    },
    {
      name: "Upload the company logo",
      required: false,
      fields: inputsConfig.logo_pic,
    },
    {
      name: "Company description",
      required: false,
      fields: inputsConfig.company_description,
    },
    {
      name: "Industry",
      required: false,
      fields: inputsConfig.industry,
    },
    {
      name: "Visibility",
      description: "Do you want the company to be displayed anonymously?",
      required: false,
      fields: inputsConfig.anonymous,
    },
    {
      name: "New team name",
      required: true,
      fields: inputsConfig.team_name,
    },
    {
      name: "Default challenger type",
      required: false,
      fields: inputsConfig.default_challenger_type,
    },
    {
      name: "Default challenger role",
      required: false,
      fields: inputsConfig.default_challenger_role,
    },
  ],
};
